import React, { useEffect, useState } from 'react'
import { Card,CardBody} from '../../components/card/card'
import { Loader, printLocation } from '../../utils/helper'
import { asset } from '../../api'
import { toast } from "react-toastify";
import { Modal, Button, Form } from "react-bootstrap";
import PageAssetProfile from './detail';

const AssetDetailModal = ({ asset, show, handleClose }) => (
    <Modal dialogClassName="modal-90w" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        
      </Modal.Header>
      <Modal.Body>
        <PageAssetProfile assetId={asset.id} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
);
  

const LocationItem = ({ location, expandedAll }) => {
    const [expanded, setExpanded] = useState(expandedAll);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [showModal, setShowModal] = useState(false);

  const handleAssetClick = (asset) => {
    setSelectedAsset(asset);
    setShowModal(true);
  };

    
    
    useEffect(() => {
        
        setExpanded(expandedAll)

    },[expandedAll])
  
    return (
      <div className=" mb-2">
        <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{printLocation(location.location_name)} </h5>
                <button className={`btn btn-${expanded?'danger':'primary'} btn-sm`} onClick={() => setExpanded(!expanded)}>
            {expanded ? <i className='bi bi-x'></i> :  <i className='bi bi-arrows-expand'></i>}
          </button>
        </div>
            {expanded && (
                <Card>    
          <CardBody className="card-body">
            {location.assets.length > 0 && (
              <div>
                <h6>Assets:</h6>
                <ul className="list-group">
                  {location.assets.map((asset) => (
                    <li key={asset.id} className="list-group-item" onClick={() => handleAssetClick(asset)} style={{ cursor: 'pointer' }}>
                      {asset.asset_name} (Model: {asset.asset_model}, Serial: {asset.serial_number})
                    </li>
                  ))}
                </ul>
              </div>
                        )}
                    
            {location.sublocations.length > 0 && (
              <div>
                <h6 className="mt-2">Locations:</h6>
                {location.sublocations.map((sub) => (
                  <LocationItem key={sub.id} location={sub} expandedAll={expandedAll} />
                ))}
              </div>
            )}
                    </CardBody>
                    </Card>
            )}
            
            {selectedAsset && (
        <AssetDetailModal asset={selectedAsset} show={showModal} handleClose={() => setShowModal(false)} />
      )}
      </div>
    );
};
  

const filterLocations = (locations, searchTerm) => {
  
    return locations.filter((location) =>
      location.location_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      location.sublocations.some((sub) => sub.location_name.toLowerCase().includes(searchTerm.toLowerCase())) ||

      location.sublocations.some((sub) => sub.assets.some((a)=>a.asset_name.toLowerCase().includes(searchTerm.toLowerCase())))
    )
  };
  

export const HierarchyView = ({queryParam}) => {
    const [loading, setLoading] = useState(false)
    const [datas, setDatas] = useState([])
    const [expandedAll, setExpandedAll] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    
    const getData = async () => {
          try {
              setLoading(true);
             
              const res = await asset.listByLocationHierarchy(queryParam);
              if (res.ok) {
                const body = await res.json();
                let data = body.data;
                if (data) {        
                  setDatas(data);
                }
              }
              setLoading(false);
            } catch (e) {
              setLoading(false);
              toast.error(e.message);
              console.error(e);
            }

    }

    useEffect(() => {
       getData() 
    }, [queryParam])
    
    const filteredLocations = filterLocations(datas, searchTerm);
  return (
    <Card>
    <CardBody>
      <Loader loading={loading}>
      <div className="container mt-3">
      <div className="d-flex justify-content-between mb-3">
        <h2>Locations</h2>
        <button className="btn btn-secondary" onClick={() => setExpandedAll(!expandedAll)}>
          {expandedAll ? "Collapse All" : "Expand All"}
        </button>
                      </div>
                      
                      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search Location/Asset by Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
                      </Form.Group>
                      
      {filteredLocations.map((location) => (
        <LocationItem key={location.id} location={location} expandedAll={expandedAll} />
      ))}
    </div>
      </Loader>
    </CardBody>
  </Card>
  )
}
